<h5 mat-dialog-title>
    <div class="col-md-12 p-0 row delete-header">
        <div class="col-md-10 p-0 post-lca-title">Post Details</div>
        <div class="col-md-2 p-0 justify-content-end d-flex">
        <i (click)="onDismiss();" class="close-icon pi pi-times"></i>
        </div>
    </div>
</h5>
<div class="post-lca-form" mat-dialog-content>
    <div class="p-field row col-md-12 p-3 mb-0 dashed-border-bottom">
        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>LCA ID</b></p>
            <p class="col-md-6 p-0">{{lcaData.id}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>Petitioner</b></p>
            <p class="col-md-6 p-0">{{lcaData.companyName}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>Location</b></p>
            <p class="col-md-6 p-0">{{lcaData.location}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>Posted</b></p>
            <p class="col-md-6 p-0">{{lcaData.postedDate | ImgDateFormat}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>#Positions</b></p>
            <p class="col-md-6 p-0">{{lcaData.newEmploymentCount}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0"><b>No.of days to be Posted</b></p>
            <p class="col-md-6 p-0">{{lcaData.daysPosted}}</p>
        </div>

        <div class="row col-md-12 p-0">
            <p class="col-md-6 p-0 m-0"><b>Take Down LCA</b></p>
            <p class="col-md-6 p-0 m-0">
                <span *ngIf="lcaData.isAutoTakeDown; else manualTakeDown">Auto Take Down</span>
                <ng-template #manualTakeDown>
                    <span>Manual Take Down</span>
                </ng-template>
            </p>
        </div>
    </div>

    <div class="p-field row p-3 mb-0 dashed-border-bottom">
        <label class="col-md-12 p-0 pb-2 post-lca-form-main-label">URL for the posted LCA</label>
        <div class="row col-md-12 p-0">
          <div class="col-md-6 p-0">
              <p>Use this URL to view all posted LCAs.</p>
              <a href="{{lcaData.postedLcaURL}}" target="_blank">{{lcaData.postedLcaURL}}</a>
          </div>
        </div>
    </div>

    <div class="p-field row p-3 mb-0 ">
        <label class="col-md-12 p-0 pb-2 post-lca-form-main-label">Button Snippet</label>
        <div class="row col-md-12 p-0">
            <div class="row col-md-12 p-0 border-bottom">
                <div class="col-md-10 p-0 mb-2"><p class="m-0"><b>Code</b></p></div>
                <div class="col-md-2 p-0 mb-2 text-right"><p class="m-0 pointer" label="COPY URL" (click)="copyUrl()"><i class="pi pi-copy"></i>
                    Copy</p></div>
            </div>
            <div class="row col-md-12 p-4">
                <div class="col-md-8 pl-0">
                <pre>{{ htmlTemplate }}</pre>
                </div>
            </div>
        </div>
    </div>
</div>